import { render, staticRenderFns } from "./TaskRemindersInput.vue?vue&type=template&id=61516df3"
import script from "./TaskRemindersInput.vue?vue&type=script&lang=js"
export * from "./TaskRemindersInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports